export default [
    {
        path: 'paciente',
        component: () => import(
            /* webpackChunkName: 'cadastro-paciente' */
            '@/views/cadastro/paciente/Index'
        ),
        redirect: 'paciente/index',
        children: [
            {
                name: 'cadastro-paciente-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-paciente' */
                    '@/views/cadastro/paciente/List.vue'
                ),
            },
            {
                name: 'cadastro-paciente-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-paciente' */
                    '@/views/cadastro/paciente/Form.vue'
                ),
            },
            {
                name: 'cadastro-paciente-show',
                path: 'show/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-paciente' */
                    '@/views/cadastro/paciente/Form.vue'
                ),
            },
            {
                name: 'cadastro-paciente-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-paciente' */
                    '@/views/cadastro/paciente/Form.vue'
                ),
            },
        ],
    },
]